<template>
  <div
    v-on:click="redirect"
    class="py-3 flex w-full"
    :class="{ 'border-b': show_border }"
  >
    <div class="flex w-full items-start">
      <!-- Icon -->
      <div v-if="icon" class="w-icon h-icon mr-2 flex-shrink-0">
        <img :src="require('@/assets/icons/' + icon)" />
      </div>

      <!-- Content area: title (wraps) + toggle aligned right -->
      <div class="flex-grow flex flex-col w-full">
        <div class="flex items-start justify-between w-full">
          <!-- Title (wraps text) -->
          <div
            class="text-md font-semibold pr-2 break-words whitespace-normal"
            style="word-break: break-word;"
          >
            <span v-text="title"></span>
          </div>

          <!-- Toggle (fixed width, aligned right) -->
          <div
            class="text-sm h-icon flex items-center justify-end flex-shrink-0 ml-2"
            style="width: 75px;"
          >
            <span class="truncate" v-text="value"></span>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-setting-card-item",
  props: {
    title: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    href: {
      type: String,
    },
    show_border: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    redirect() {
      if (this.href != null) {
        this.$router.push(this.href);
      }
    },
  },
};
</script>

<style scoped>
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
